<template>
	<div>
	    <v-list nopadding two-line>
	        <v-list-tile>
                <v-list-tile-content>
                    <v-list-tile-sub-title>Ledger</v-list-tile-sub-title>
                    <v-list-tile-title>{{data.accountLedgerName}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
	    </v-list>
 	</div>
</template>

<script>
	export default{
		props:['data']
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/expense_categories/display_tabs/details.vue